function havePhoneNumber(user?: Partial<User>): boolean {
  return Boolean(user?.communication?.phone1);
}

export default havePhoneNumber;
